var exports = {
  "nM": "CrosspostPublishNudge.module__row___UUpWRl",
  "Io": "CrosspostPublishNudge.module__pill___UUpWRl",
  "Kk": "CrosspostPublishNudge.module__icon___UUpWRl",
  "Pf": "CrosspostPublishNudge.module__label___UUpWRl",
  "_4": "CrosspostPublishNudge.module__publishButton___UUpWRl",
  "r": "CrosspostPublishNudge.module__dismissButton___UUpWRl",
  "EL": "CrosspostPublishNudge.module__hideForeverButton___UUpWRl",
  "MW": "CrosspostPublishNudge.module__dismissIcon___UUpWRl",
};

module.exports = exports;
